'use strict';

/**
 * The directive module contains directives used across the application's various pieces.
 */

var directives = angular.module('dash.directives', []);

directives.directive('dropdownButton', require('./DropdownButtonDirective'));



// WEBPACK FOOTER //
// ./src/app/dash/directives/index.js